module.exports = __webpack_public_path__ + "static/img/di5.1e4a707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/di5.png
// module id = JOW7
// module chunks = 1